import { Field } from "@components/ui/form/Field"
import { ToolTip } from "@components/ui/tooltip"
import { Heading } from "@components/ui/typograhpy/Heading"
import { Text } from "@components/ui/typograhpy/Text"
import { useFormikContext } from "formik"
import { FC } from "react"

export type NewsletterPreferenceId =
  | "viesus-cloud-product-updates"
  | "viesus-news"
  | "viesus-product-updates"

export const NEWSLETTER_OPTIONS: {
  label: string
  preferenceId: NewsletterPreferenceId
  tooltip: string
}[] = [
  {
    label: "Viesus Cloud Product Updates",
    preferenceId: "viesus-cloud-product-updates",
    tooltip: "Receive Viesus Cloud product updates.",
  },
  {
    label: "Viesus News",
    preferenceId: "viesus-news",
    tooltip: "Receive general news about Viesus and the team.",
  },
  {
    label: "Viesus Product Updates",
    preferenceId: "viesus-product-updates",
    tooltip: "Receive Viesus product updates.",
  },
]

export const ProfileNewsletter: FC = () => {
  const { isSubmitting } = useFormikContext<any>()

  return (
    <div className="mb-3 md:mb-0">
      <Heading variant="h6" as="h6" className="mb-4">
        Newsletter
      </Heading>
      <Text variant="regular" className="mb-6">
        Want to stay updated on all things Viesus Cloud? Sign up for our
        newsletter!
      </Text>
      {NEWSLETTER_OPTIONS.map((option) => (
        <ToolTip
          triggerAsChild
          key={option.preferenceId}
          alignOffset={10}
          trigger={
            <div>
              <Field
                field="checkbox"
                className="mb-4"
                name={`preferences.${option.preferenceId}`}
                id={option.preferenceId}
                label={option.label}
                status={isSubmitting ? "disabled" : "idle"}
              />
            </div>
          }
        >
          {option.tooltip}
        </ToolTip>
      ))}
    </div>
  )
}
